import actionTypes from '../../action-types'

export default (payload) => ({
  type: actionTypes.IMPORTERS.MANUAL_IMPORT,
  payload,
})
